// #region Imports
import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState, useRef } from "react"
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css"
import TableContainer from "../../components/Common/TableContainerCargos"
import * as Yup from "yup"
import { useFormik } from "formik"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { Link, useNavigate } from "react-router-dom"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import DeleteModal from "../../components/Common/DeleteModal"
import { useDispatch } from "react-redux"
import { withTranslation } from "react-i18next"
import CargosInsertModal from "../../components/Common/CargosInsertModal"
import GastosInsertModal from "../../components/Common/GastosInsertModal"
import CajaChicaContainer from "../../components/CajaChica/CajaChicaContainer"
import IndeterminateCheckbox from "components/Common/IndeterminateCheckbox"
import AsyncAlumnosSelect from "components/Common/AsyncAlumnosSelect"

import {
  Container,
  Col,
  Row,
  InputGroup,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
  Card,
  CardBody,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
  Button,
  FormGroup,
} from "reactstrap"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// #endregion

// #region selectors
import {
  useEstadoCuenta,
  useCajaIdAlumno,
  useCajaError,
  useCajaIsLoading,
  useDescuentosCatalogo,
  useGrupoServiciosEquivalentes,
  useFormasPagoSAT,
  useUsosCFDI40,
  useAuthIsAuthenticated,
  useCampusVirtualIdCampus,
  useAuthIdPersonaAuthenticated,
  useCajaoRecibo,
  useCajaId_Recibo_Pago,
  useCajaAlumnos,
  useControlEscolarAlumnos,
  useCajaoUltimoCargoIsLoading,
  useCajaoAlumno,
  useAuthPermiso,
  useCajaIdServicioconDescuento as idServicioDescontable,
  useCajaRowsAffectedDelIdRelDesCargo,
  useCajaRowsAffectedDeloCargo,
  useCajaIsProcessingDeloCargo,
  useCajaMensajeExitoso,
} from "store/selectors"
// #endregion

// #region actions
import {
  getCajaEstadoCuenta as onGetEstadoCuenta,
  getCajaEstadoCuentaSuccess as SetEstadoCuenta,
  getCajaDescuentosCatalogo as onGetDescuentosCatalogo,
  getCajaDescuentosxidCuenta as onGetDescuentosxidCuenta,
  getCajaGSEquivalentes as onGetGrupoServiciosEquivalentes,
  getCajaFormasPagoSAT as onGetFormasPagoSAT,
  getCajaUsosCFDI40 as onGetUsosCFDI40,
  postCajaAbonoaCuenta as onPostAbonoaCuenta,
  // SetCajaIdAlumnoSelected as onSetCajaIdAlumnoSelected,
  SetCajaoAlumnoSelected as onSetCajaoAlumnoSelected,
  delCajaDelIdRelacionDescuentoCargo as onDelIdRelacionDescuentoCargo,
  delCajaDelIdRelacionDescuentoCargoSuccess as onSetRowsAffectedDelidRelDescCargo,
  delCajaDeloCargo as onSetdelCajaDeloCargo,
  delCajaDeloCargoSuccess as onSetdelCajaDeloCargoSuccess,
  postCajaLinkPago as onPostCajaLinkPago,
  unsetCajaMensajeExito,
} from "store/actions"
// #endregion

const Caja = props => {
  //
  const history = useNavigate()
  //
  document.title = "Caja | CampusVirtual"

  // #region Init

  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: "d-m-y",
  }
  // #endregion

  // #region react-redux
  const dispatch = useDispatch()
  // #endregion

  // #region useRef
  const isFirstRender = useRef(true)
  const isFirstRender2 = useRef(true)
  const flatpickrRef = useRef(null)
  // #endregion

  // #region selectors
  const idAlumnoSelected = useCajaIdAlumno()
  const oAlumno = useCajaoAlumno()
  const alumnos = useCajaAlumnos()
  const controlEscolarAlumnos = useControlEscolarAlumnos()
  const edoCuenta = useEstadoCuenta()
  const error = useCajaError()
  const isLoading = useCajaIsLoading()
  const descuentosCatalogo = useDescuentosCatalogo()
  const grupoServiciosEquivalentes = useGrupoServiciosEquivalentes()
  const formasPagoSAT = useFormasPagoSAT()
  const UsosCFDI40 = useUsosCFDI40()
  const isAuthenticated = useAuthIsAuthenticated()
  const idPersonaAuthenticated = useAuthIdPersonaAuthenticated()
  const idCampus = useCampusVirtualIdCampus()
  const oRecibo = useCajaoRecibo()
  const id_Recibo_Pago = useCajaId_Recibo_Pago()
  const oCargoIsLoading = useCajaoUltimoCargoIsLoading()
  const rowsAffectedDelIdRelDesCargo = useCajaRowsAffectedDelIdRelDesCargo()
  const rowsAffectedDeloCargo = useCajaRowsAffectedDeloCargo()
  const isAdministradorGeneral = useAuthPermiso(["sis_administrador_general"])
  const isCajero = useAuthPermiso(["sis_cajero"])
  const isProcessingDeloCargo = useCajaIsProcessingDeloCargo()
  const mensajeExito = useCajaMensajeExitoso()
  // #endregion selectors

  // #region Internal States
  const [modal, setModal] = useState(false)
  const [modalGastos, setModalGastos] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [job, setJob] = useState(null)
  const [descuento, setDescuento] = useState(null)
  const [oCargo, setoCargo] = useState(null)
  const [selectedOptionAlumno, setSelectedOptionAlumno] = useState()
  //const [idAlumnoSelected, setIdAlumnoSelected] = useState()
  const [SelecetedOptionAlumno, setSelecetedOptionAlumno] = useState({})
  const [selectedOptionFormaPago, setSelectedOptionFormaPago] = useState(null)
  const [selectedOptionDescuento, setSelectedOptionDescuento] = useState(null)
  const [pick_date, setPickDate] = useState("")
  const [alumnosOptions, setAlumnosOptions] = useState([])
  const [optionsDescuentos, setOptionsDescuentos] = useState([])
  const [optionsFormasPago, setOptionsFormasPago] = useState([])
  const [totalCost, setTotalCost] = useState(0)
  const [selectedIds, setSelectedIds] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [defaultOptions, setDefaultOptions] = useState([])
  const [isDisabledPagarButton, setDisabledPagarButton] = useState(true)
  const [borrandoObjeto, setBorrandoObjeto] = useState("")

  const [rowsAffected, setRowsAffected] = useState(0)

  // #endregion

  // Selecciona al alumno
  // const setIdAlumnoSelected = idAlumno => {
  //   dispatch(onSetCajaIdAlumnoSelected(idAlumno))
  // }

  const toggleRefresh = () => {
    setRefresh(prev => !prev) // Cambia el valor de refresh
  }

  const handlePagarButton = () => {
    if (isAuthenticated && idPersonaAuthenticated > 0) {
      dispatch(
        onPostAbonoaCuenta({
          nombreSolicitud: "abonoacuenta",
          idPersona: idPersonaAuthenticated,
          idCuenta: edoCuenta.Cuentas[0].id_Cuenta,
          CantidadAbono: totalCost,
          idFormaPago: 1,
          fechaPago: "2024-11-17",
          fechaReciboPago: "2024-11-17",
          idPersonaPagadora: edoCuenta.Cuentas[0].id_Persona,
          generaPDF: true,
          testing: 917648,
        })
      )
    } else {
      toast.error("Debes estar autentificado.", {
        autoClose: 2000,
      })
    }
  }

  const picks = () => {
    setPickDate(new Date())
  }

  // #region useEffects

  useEffect(() => {
    console.log("selectedOptionFormaPago:", selectedOptionFormaPago)
    const isButtonEnabled =
      oAlumno?.id_Alumno > 0 &&
      selectedOptionFormaPago?.value > 0 &&
      totalCost > 0

    setDisabledPagarButton(!isButtonEnabled)
  }, [oAlumno, selectedOptionFormaPago, totalCost])

  useEffect(() => {
    if (rowsAffectedDelIdRelDesCargo > 0) {
      dispatch(
        onGetEstadoCuenta({
          nombreSolicitud: "getestadocuentaxidalumno",
          idAlumno: oAlumno.id_Alumno,
        })
      )
      toast.success("Descuento Cancelado", {
        autoClose: 2000,
      })
      dispatch(onSetRowsAffectedDelidRelDescCargo(0))
    }
  }, [rowsAffectedDelIdRelDesCargo])

  useEffect(() => {
    if (rowsAffectedDeloCargo > 0) {
      dispatch(
        onGetEstadoCuenta({
          nombreSolicitud: "getestadocuentaxidalumno",
          idAlumno: oAlumno.id_Alumno,
        })
      )
      toast.success("Cargo Cancelado", {
        autoClose: 2000,
      })
      dispatch(onSetdelCajaDeloCargoSuccess(0))
    }
  }, [rowsAffectedDeloCargo])

  // ControlEscolar manda oAlumno
  useEffect(() => {
    //console.log("useEffect::oAlumno: ", oAlumno)
    // Creo el oAlumnoOption
    if (oAlumno && oAlumno.id_Alumno) {
      setSelecetedOptionAlumno({
        value: oAlumno.id_Alumno,
        label: oAlumno.Nombres,
      })
      setSelectedOptionFormaPago(null)
      if (idCampus > 0) {
        setTotalCost(0)
        if (oAlumno.id_Alumno > 0) {
          dispatch(
            onGetEstadoCuenta({
              nombreSolicitud: "getestadocuentaxidalumno",
              idAlumno: oAlumno.id_Alumno,
            })
          )
        } else {
          // Invalido el estado de cuenta
          SetEstadoCuenta({ Cuentas: [{ lista_cargos: [] }] })
        }
      }
    } else {
      // Invalido el estado de cuenta
      SetEstadoCuenta({ Cuentas: [{ lista_cargos: [] }] })
    }
    // Traigo el oEstadoCuenta
  }, [oAlumno])

  // picks
  useEffect(() => {
    picks()
  }, [])

  useEffect(() => {
    //console.log("idCampus:", idCampus)
  }, [idCampus])

  // setOptionsDescuentos
  useEffect(() => {
    setOptionsDescuentos(adaptaDescuentos(descuentosCatalogo))
  }, [descuentosCatalogo])

  // setOptionsFormasPago
  useEffect(() => {
    setOptionsFormasPago(adaptaFormasPago(formasPagoSAT))
  }, [formasPagoSAT])

  //onGetDescuentosCatalogo
  useEffect(() => {
    if (oAlumno.id_Alumno > 0) {
      if (idCampus > 0) {
        dispatch(
          onGetDescuentosCatalogo({
            nombreSolicitud: "getdescuentoscatalogo",
            idAlumno: oAlumno.id_Alumno,
          })
        )
      }
    }
  }, [dispatch, oAlumno, idCampus])

  //onGetDescuentosxidCuenta
  useEffect(() => {
    if (idCampus > 0 && oAlumno.id_Alumno > 0) {
      if (edoCuenta.Cuentas[0].id_Cuenta > 0) {
        // console.log(
        //   "useEffect::edoCuenta.Cuentas[0].id_Cuenta: ",
        //   edoCuenta.Cuentas[0].id_Cuenta
        // )
        dispatch(
          onGetDescuentosxidCuenta({
            nombreSolicitud: "getdescuentosxidcuenta",
            idCuenta: edoCuenta.Cuentas[0].id_Cuenta,
          })
        )
      }
    }
  }, [dispatch, oAlumno, edoCuenta])

  // onGetGrupoServiciosEquivalentes
  useEffect(() => {
    if (idCampus > 0) {
      if (grupoServiciosEquivalentes.length === 0) {
        dispatch(
          onGetGrupoServiciosEquivalentes({
            nombreSolicitud: "getgruposerviciosequivalentes",
          })
        )
      }
    }
  }, [dispatch, grupoServiciosEquivalentes])

  // onGetFormasPagoSAT
  useEffect(() => {
    if (idCampus > 0) {
      if (formasPagoSAT.length === 0) {
        dispatch(
          onGetFormasPagoSAT({
            nombreSolicitud: "getformaspagosat",
          })
        )
      }
    }
  }, [dispatch, formasPagoSAT])

  // onGetUsosCFDI40
  useEffect(() => {
    if (idCampus > 0) {
      if (UsosCFDI40.length === 0 && oAlumno?.id_Alumno > 0) {
        dispatch(
          onGetUsosCFDI40({
            nombreSolicitud: "getlistausoscfdi40",
            idAlumno: oAlumno.id_Alumno,
          })
        )
      }
    }
  }, [dispatch, UsosCFDI40])

  // Calcula el costo total de los cargos
  useEffect(() => {
    if (idCampus > 0) {
      if (edoCuenta) {
        //console.log("edoCuenta.Balance:", edoCuenta.Balance)
        if (edoCuenta.Balance > 0) {
          setTotalCost(edoCuenta.Balance)
        } else {
          setTotalCost(0)
        }
      }
    }
  }, [edoCuenta])

  useEffect(() => {
    if (error && error.length) {
      console.log("useEffect::linea 382:error:", error)
      toast.error(error, {
        autoClose: 2000,
      })
    }
  }, [error])

  useEffect(() => {
    if (idCampus > 0) {
      if (id_Recibo_Pago > 0) {
        console.log("Linea 311::useEffect::id_Recibo_Pago", id_Recibo_Pago)
        const mensajeToast = "id_Recibo_Pago # " + id_Recibo_Pago
        toast.success(mensajeToast, {
          autoClose: 2000,
        })
        setTimeout(() => {
          history("/caja/recibo/" + id_Recibo_Pago)
        }, 2000)
      }
    }
    //
  }, [dispatch, id_Recibo_Pago])

  useEffect(() => {
    if (mensajeExito && mensajeExito.length > 0) {
      toast.success(mensajeExito, {
        autoClose: 2000,
      })
      dispatch(unsetCajaMensajeExito())
    }
    //
  }, [dispatch, mensajeExito])

  useEffect(() => {
    //console.log("selectedIds updated: ", selectedIds)
    toggleRefresh()
  }, [selectedIds])

  useEffect(() => {
    const alumnosConvertidos = convierte(controlEscolarAlumnos)
    setDefaultOptions(alumnosConvertidos ? alumnosConvertidos : [])
  }, [controlEscolarAlumnos])

  // #endregion

  const convierte = alumnos =>
    alumnos.map(alumno => {
      return {
        value: alumno.id_Alumno,
        label: alumno.apellidopaterno_apellido_materno_nombre,
      }
    })

  const adaptaDescuentos = descuentosCatalogo =>
    descuentosCatalogo.map(descuento => {
      return {
        value: descuento.id_Descuento,
        label: descuento.Clave_Descuento + " - " + descuento.Nombre_Descuento,
      }
    })

  const adaptaFormasPago = formasPagoSAT =>
    formasPagoSAT.map(formaPago => {
      return {
        value: formaPago.id_Forma_Pago,
        label: formaPago.Nombre_Forma_Pago,
      }
    })

  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      jobId: (job && job.jobId) || "",
      jobTitle: (job && job.jobTitle) || "",
      companyName: (job && job.companyName) || "",
      location: (job && job.location) || "",
      experience: (job && job.experience) || "",
      position: (job && job.position) || "",
      type: (job && job.type) || "",
      status: (job && job.status) || "",
    },
    validationSchema: Yup.object({
      jobId: Yup.string()
        .matches(/[0-9\.\-\s+\/()]+/, "Please Enter Valid Job Id")
        .required("Please Enter Your Job Id"),
      jobTitle: Yup.string().required("Please Enter Your Job Title"),
      companyName: Yup.string().required("Please Enter Your Company Name"),
      location: Yup.string().required("Please Enter Your Location"),
      experience: Yup.string().required("Please Enter Your Experience"),
      position: Yup.string().required("Please Enter Your Position"),
      type: Yup.string().required("Please Enter Your Type"),
      status: Yup.string().required("Please Enter Your Status"),
    }),
    onSubmit: values => {
      if (isEdit) {
        const updateJobList = {
          id: job ? job.id : 0,
          jobId: values.jobId,
          jobTitle: values.jobTitle,
          companyName: values.companyName,
          location: values.location,
          experience: values.experience,
          position: values.position,
          type: values.type,
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values.status,
        }
        // update Job
        //dispatch(onUpdateJobList(updateJobList))
        validation.resetForm()
      } else {
        const newJobList = {
          id: Math.floor(Math.random() * (30 - 20)) + 20,
          jobId: values["jobId"],
          jobTitle: values["jobTitle"],
          companyName: values["companyName"],
          location: values["location"],
          experience: values["experience"],
          position: values["position"],
          type: values["type"],
          postedDate: "02 June 2021",
          lastDate: "25 June 2021",
          status: values["status"],
        }
        // save new Job
        //dispatch(onAddNewJobList(newJobList))
        validation.resetForm()
      }
      toggle()
    },
  })

  const toggle = () => {
    if (modal) {
      setModal(false)
      setJob(null)
    } else {
      setModal(true)
    }
  }

  const toggleGastos = () => {
    if (modalGastos) {
      setModalGastos(false)
    } else {
      setModalGastos(true)
    }
  }

  //delete Job
  const [deleteModal, setDeleteModal] = useState(false)

  const cargoVencido = fechaExpiracion => {
    const fechaHoy = new Date() // Obtiene la fecha actual
    const fechaExp = new Date(fechaExpiracion) // Convierte la fecha de expiración a un objeto Date

    // Ajuste para comparar solo la fecha (sin la hora)
    fechaHoy.setHours(0, 0, 0, 0)
    fechaExp.setHours(0, 0, 0, 0)

    if (fechaExp < fechaHoy) {
      return true
    } else {
      return false
    }
  }

  const calculaStatusExpiracionCargo = fechaExpiracion => {
    const fechaHoy = new Date() // Obtiene la fecha actual
    const fechaExp = new Date(fechaExpiracion) // Convierte la fecha de expiración a un objeto Date

    // Ajuste para comparar solo la fecha (sin la hora)
    fechaHoy.setHours(0, 0, 0, 0)
    fechaExp.setHours(0, 0, 0, 0)

    if (fechaExp > fechaHoy) {
      return "Activo"
    } else if (fechaExp.getTime() === fechaHoy.getTime()) {
      return "xVencer"
    } else {
      return "Vencido"
    }
  }

  const handlerOptionSelected = selectedOption => {
    console.log("handlerOptionSelected: ", selectedOption)
    dispatch(
      onSetCajaoAlumnoSelected({
        id_Alumno: selectedOption.value,
        Nombres: selectedOption.label,
      })
    )
  }

  const handleRowsSelectedFn = rowsSelected => {
    //console.log("handleRowsSelectedFn: ", rowsSelected)
    const costoTotal = rowsSelected.reduce(
      (total, item) => total + (item.cantidad || 0),
      0
    )
    setTotalCost(costoTotal)
  }

  const onClickDeleteDescuento = oDescuento => {
    setDescuento(oDescuento)
    setBorrandoObjeto("descuento")
    setDeleteModal(true)
  }

  const onClickDeleteCargo = oCargo => {
    setoCargo(oCargo)
    setBorrandoObjeto("cargo")
    setDeleteModal(true)
  }

  const onClickRefreshButton = () => {
    dispatch(
      onGetEstadoCuenta({
        nombreSolicitud: "getestadocuentaxidalumno",
        idAlumno: oAlumno.id_Alumno,
      })
    )
  }

  const onClickSolicitaLinkPago = () => {
    dispatch(
      onPostCajaLinkPago({
        nombreSolicitud: "linkpagopersonal",
        idAlumno: oAlumno.id_Alumno,
        incluirCargosFuturos: false,
        privateKey: "key_g8zhQgBdj9HKejsuh2X8tLB",
        link: "https://pay.conekta.com/link/",
      })
    )
  }

  const handleDeleteObjeto = () => {
    if (borrandoObjeto === "descuento") {
      if (descuento && descuento.id_Relacion_Descuento_Cargo > 0) {
        //console.log("handleDeleteDescuento")
        dispatch(
          onDelIdRelacionDescuentoCargo({
            nombreSolicitud: "delidrelaciondescuentocargo",
            idRelacionDescuentoCargo: descuento.id_Relacion_Descuento_Cargo,
          })
        )
      }
    } else {
      // Borrando oCargo
      dispatch(
        onSetdelCajaDeloCargo({
          nombreSolicitud: "delocargo",
          idCargo: oCargo.id_Cargo,
        })
      )
    }
    setBorrandoObjeto("")
    setDeleteModal(false)
  }

  const onClickAplicaDescuentoButton = data => {
    console.log("onClickAplicaDescuentoButton: ", data)
  }

  const handleAplicaDescuento = () => {}

  const columns = useMemo(
    () => [
      {
        id: "select",
        header: "Pagar",
        accessorKey: "id_Cargo",
        cell: ({ row, table }) => (
          <Row className="">
            <Col>
              <IndeterminateCheckbox
                {...{
                  checked: row.getIsSelected(),
                  disabled: cargoVencido(row.original.Fecha_Expiracion), //!row.getCanSelect(),
                  indeterminate: row.getIsSomeSelected(),
                  onChange: () =>
                    table.options.meta.customToggleSelected(
                      row,
                      !row.getIsSelected()
                    ),
                }}
              />
            </Col>
            {row.getCanExpand() ? (
              <Col>
                <Button
                  color="link"
                  {...{
                    onClick: row.getToggleExpandedHandler(),
                    style: { cursor: "pointer", outline: "none !important" },
                  }}
                >
                  {row.getIsExpanded() ? (
                    <i className="bx bx-down-arrow-alt" />
                  ) : (
                    <i className="bx bx-right-arrow-alt" />
                  )}
                </Button>
              </Col>
            ) : null}{" "}
          </Row>
        ),
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Concepto",
        accessorKey: "concepto",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Desc",
        accessorKey: "Descripcion",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Monto",
        enableColumnFilter: false,
        enableSorting: false,
        accessorKey: "cantidad",
        cell: cellProps => {
          return `$${cellProps.row.original.cantidad}`
        },
      },
      {
        header: "Status",
        accessorKey: "Fecha_Expiracion",
        enableColumnFilter: false,
        enableSorting: false,
        cell: cellProps => {
          const statusCargo = calculaStatusExpiracionCargo(
            cellProps.row.original.Fecha_Expiracion
          )
          switch (statusCargo) {
            case "Activo":
              return <Badge className="bg-success">Activo</Badge>
            case "xVencer":
              return <Badge className="bg-info">xVencer</Badge>
            case "Vencido":
              return <Badge className="bg-danger">Vencido</Badge>
          }
        },
      },
      {
        header: "Parcial",
        enableColumnFilter: false,
        enableSorting: false,
        accessorKey: "Abonado_Parcialmente",
        cell: cellProps => (
          <div
            style={{
              textAlign: "center",
              verticalAlign: "middle", // Asegura alineación vertical
              padding: "10px",
              fontSize: "05px !important",
            }}
          >
            <Input
              type="checkbox"
              id={`AbonadoParcialmente_${cellProps.row.original.id_Cargo}`}
              checked={
                cellProps.row.original.Abonado_Parcialmente ? true : false
              }
              readOnly
              className="form-check"
            />
          </div>
        ),
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        size: 30,
        cell: cellProps => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0">
              {isAdministradorGeneral ? (
                <li>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-info"
                    onClick={() => {
                      const jobData = cellProps.row.original
                      handleJobClick(jobData)
                    }}
                    id={`edittooltip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-pencil-outline" />
                    <UncontrolledTooltip
                      placement="top"
                      target={`edittooltip-${cellProps.row.original.id}`}
                    >
                      Editar
                    </UncontrolledTooltip>
                  </Link>
                </li>
              ) : (
                <></>
              )}
              {!cargoVencido(cellProps.row.original.Fecha_Expiracion) &&
              isCajero &&
              idServicioDescontable(cellProps.row.original.id_Servicio) ? (
                <li>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-warning"
                    onClick={() => {
                      onClickAplicaDescuentoButton(cellProps.row.original)
                    }}
                    id={`discounttip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-tag" />
                    <UncontrolledTooltip
                      placement="top"
                      target={`discounttip-${cellProps.row.original.id}`}
                    >
                      Aplicar Descuento
                    </UncontrolledTooltip>
                  </Link>
                </li>
              ) : (
                <></>
              )}
              {!cargoVencido(cellProps.row.original.Fecha_Expiracion) ? (
                <li>
                  <Link
                    to="#"
                    className="btn btn-sm btn-soft-danger"
                    onClick={() => {
                      const cargoData = cellProps.row.original
                      onClickDeleteCargo(cargoData)
                    }}
                    id={`deletetooltip-${cellProps.row.original.id}`}
                  >
                    <i className="mdi mdi-delete-outline" />
                    <UncontrolledTooltip
                      placement="top"
                      target={`deletetooltip-${cellProps.row.original.id}`}
                    >
                      Cancelar
                    </UncontrolledTooltip>
                  </Link>
                </li>
              ) : (
                <></>
              )}
            </ul>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteObjeto}
        onCloseClick={() => {
          setBorrandoObjeto("")
          setDeleteModal(false)
        }}
        message={`¿Estás Seguro que quieres borrar el ${borrandoObjeto}?`}
      />
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={props.t("Caja")}
            breadcrumbItem={props.t("Caja")}
          />
          <Row>
            <Col xs={12}>
              <Card>
                <ToastContainer />
                <CardBody>
                  <Form className="" encType="multipart/form-data">
                    <div>
                      <Row key={1}>
                        <Col lg={4}>
                          <AsyncAlumnosSelect
                            value={SelecetedOptionAlumno}
                            defaultOptions={defaultOptions}
                            idCampus={idCampus}
                            handlerOptionSelected={handlerOptionSelected}
                          />
                        </Col>

                        <Col lg={3}>
                          <InputGroup>
                            <Flatpickr
                              ref={flatpickrRef}
                              id="Fecha_pago"
                              value={Date.parse(pick_date)}
                              className="form-control d-block"
                              placeholder="Fecha Pago"
                              options={optionsFlatpickr}
                            />
                          </InputGroup>
                        </Col>

                        <Col lg={3}>
                          <Select
                            value={selectedOptionFormaPago}
                            onChange={setSelectedOptionFormaPago}
                            options={optionsFormasPago}
                            isSearchable={true}
                            placeholder="Forma de Pago ..."
                            className="select2-selection"
                          />
                        </Col>

                        <Col
                          lg={1}
                          className="d-flex justify-content-start align-items-center"
                        >
                          <div className="form-check form-check-primary">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="customCheckcolor1"
                              checked={
                                edoCuenta.Cuentas[0].id_Contribuyente < 1
                                  ? false
                                  : true
                              }
                              onChange={() => {}}
                            />

                            <label
                              className="form-check-label"
                              htmlFor="customCheckcolor1"
                            >
                              Factura
                            </label>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <TableContainer
                    buttonClass="btn btn-success"
                    buttonName="Agregar Cargo"
                    handleUserClick={toggle}
                    isPagination={false}
                    isCustomPageSize={false}
                    isBordered={true}
                    isAddButton={true}
                    divClassName="m-0"
                    tableClass={"table-sm"}
                    columns={columns}
                    data={edoCuenta.Cuentas[0].lista_cargos || []}
                    handleRowsSelectedFn={handleRowsSelectedFn}
                    onClickDeleteDescuentoFn={onClickDeleteDescuento}
                    onClickRefreshButtonFn={onClickRefreshButton}
                    onClickAplicaDescuentoButtonFn={
                      onClickAplicaDescuentoButton
                    }
                    onClickOpengastosFn={() => {
                      setModalGastos(true)
                    }}
                    onClickContribuyentesFn={() => {}}
                    onClickSolicitaLinkPagoFn={onClickSolicitaLinkPago}
                    isLoading={isLoading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardBody>
                  <Row>
                    <Col xs={7}>
                      <div className="d-flex align-items-center mb-2">
                        <label className="m-1" htmlFor="Descuentos">
                          Descuentos:{" "}
                        </label>
                        <Select
                          idAlumnoSelected={selectedOptionDescuento}
                          onChange={setSelectedOptionDescuento}
                          options={optionsDescuentos}
                          isSearchable={true}
                          placeholder="Descuentos ..."
                          className="select2-selection w-100"
                        />
                        <div className="d-flex justify-content-end">
                          <Link
                            to="#!"
                            onClick={() => setModal(true)}
                            className="btn btn-secondary m-1 disabled"
                          >
                            Aplicar
                          </Link>
                        </div>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <label className="m-1" htmlFor="Descripcion">
                          Descripción:{" "}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          defaultValue=""
                          placeholder="Descripción ..."
                        />
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <label className="m-1" htmlFor="Comentarios">
                          Comentarios:{" "}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          defaultValue=""
                          placeholder="Comentarios ..."
                        />
                      </div>
                    </Col>
                    <Col xs={1}> </Col>
                    <Col xs={4}>
                      <div className="d-flex align-items-center mb-2">
                        <label className="m-1" htmlFor="Importe">
                          Importe:
                        </label>
                        <input
                          id="aPagar"
                          className="form-control"
                          type="text"
                          value={`$${totalCost.toLocaleString()}`}
                          placeholder="$"
                          onChange={e => {
                            //console.log(e)
                            const value = e.target.value
                            const numericValue = value.replace(/[^0-9]/g, "")
                            setTotalCost(
                              numericValue ? parseFloat(numericValue) : 0
                            )
                          }}
                        />
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <label className="m-1" htmlFor="Comision">
                          Comisión:{" "}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          defaultValue=""
                          placeholder="Comisión ..."
                        />
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <label className="m-1" htmlFor="Total">
                          Total:{" "}
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          readOnly={true}
                          value={`$${totalCost.toLocaleString()}`}
                        />
                      </div>
                      <div className="d-flex justify-content-end mt-2">
                        <Button
                          color="primary"
                          className="btn waves-effect waves-light me-1 w-lg"
                          disabled={isDisabledPagarButton}
                          onClick={handlePagarButton}
                        >
                          {" "}
                          Pagar
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal isOpen={modal} toggle={toggle} scrollable={true}>
            <ModalHeader toggle={toggle} tag="h4">
              Añadir Cargos
            </ModalHeader>
            <ModalBody>
              <CargosInsertModal
                idAlumno={oAlumno.id_Alumno}
                isLoading={oCargoIsLoading}
              />
            </ModalBody>
          </Modal>

          <Modal
            isOpen={modalGastos}
            toggle={toggleGastos}
            scrollable={true}
            size="lg"
          >
            <ModalHeader toggle={toggleGastos} tag="h4">
              Gastos y Transferencias
            </ModalHeader>
            <ModalBody>
              <CajaChicaContainer />
            </ModalBody>
          </Modal>
        </Container>
      </div>
    </React.Fragment>
  )
}

Caja.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
}

export default withTranslation()(Caja)
